export default {
  title: 'Partner toevoegen',
  mode: {
    single: 'Enkele partner',
    bulk: 'Bulk (CSV)',
  },
  buttons: {
    send_invite: 'Uitnodiging versturen',
  },
  bulk: {
    form: {
      file: {
        label: 'Partnerlijst (CSV)',
        hint: 'Één partner per rij. Verplichte kolommen: E-mail, Bedrijfsland en Geregistreerde bedrijfsnaam of Bedrijfsnaam. Merknaam is optioneel en wordt de weergavenaam voor de consument. Elke rij wordt gevalideerd voordat er iets wordt aangemaakt.',
      },
    },
    buttons: {
      select_file: 'CSV-bestand selecteren',
      download_template: 'Importsjabloon downloaden',
      import: 'Partners importeren',
    },
    columns: {
      legal_name: 'Geregistreerde bedrijfsnaam / Bedrijfsnaam',
      display_name: 'Merknaam',
      admin_email: 'E-mail',
      company_country: 'Bedrijfsland',
    },
    errors: {
      title: 'Het bestand kon niet worden geïmporteerd.',
      nothing_imported: 'Er is geen partner aangemaakt. Corrigeer de bovenstaande rijen en upload het bestand opnieuw.',
      columns: {
        row: 'Rij',
        column: 'Kolom',
        error: 'Fout',
      },
    },
    toasts: {
      queued_one:
        '{{count}} partner in wachtrij — uitnodigingen worden verstuurd zodra elke partner is aangemaakt. U ontvangt een samenvattingsmail wanneer de import klaar is.',
      queued_other:
        '{{count}} partners in wachtrij — uitnodigingen worden verstuurd zodra elke partner is aangemaakt. U ontvangt een samenvattingsmail wanneer de import klaar is.',
    },
    footnote:
      'Partners worden één voor één op de achtergrond aangemaakt met dezelfde instellingen als bij een enkele partner: uitnodigingsmail, dashboard-subdomein en standaard shopdomein. Het land bepaalt valuta en tijdzone; een staat/provincie kan later worden ingesteld via het partnerprofiel. Betalingsverwerking wordt daarna geconfigureerd op het tabblad Betalingen van elke partner.',
  },
  form: {
    name: {
      label: 'Partnernaam',
    },
    admin_email: {
      label: 'Beheerders-e-mail (ontvanger uitnodiging)',
      hint: 'We sturen een uitnodiging per e-mail om het account in te stellen.',
    },
    display_name: {
      label: 'Weergavenaam voor consumenten',
      hint: 'Het label „Mogelijk gemaakt door ___" dat klanten zien. Standaard de partnernaam als leeg gelaten.',
    },
    region: {
      label: 'Land',
      placeholder: 'Selecteer een land',
      hint: 'Bepaalt de valuta, tijdzone en uitnodigingstaal van de partner.',
      summary: 'Valuta {{currency}} · {{timezone}} · Uitnodigingstaal {{language}}',
      default_root: 'Shopdomein: nieuwe merken worden gehost op {{host}}',
    },
    sub_region: {
      label: 'Provincie',
      placeholder: 'Heel land',
      hint: 'Optioneel — leeg laten om op heel het land toe te passen.',
    },
    language: {
      label: 'Uitnodigingstaal',
      placeholder: '{{language}} (standaard)',
      hint: 'Optioneel — standaard de primaire taal van het land.',
    },
  },
  footnote:
    'Branding- en verdienstinstellingen kunnen worden geconfigureerd nadat de partner de uitnodiging heeft geaccepteerd.',
  toasts: {
    created: 'Partner aangemaakt — de uitnodiging is onderweg.',
  },
};
